// css and images
import { Outlet, useOutletContext, useParams } from "react-router-dom";
import AccountInvoiceTabs from "../AccountInvoiceTabs";
import { useEffect } from "react";


export default function VendorAccountInvoices() {
  const {invId} = useParams("invId")
  const {setInvoiceTarget} = useOutletContext()
  useEffect(() => {
    setInvoiceTarget("Vendor")
  })
  return (
    <div className="container-fluid">
      {!invId && <AccountInvoiceTabs type='Vendor'/>}
      <Outlet />
    </div>
  );
}
